import { Link } from 'react-router-dom';
import { ChevronLeftIcon } from './icons';
import styles from './BackLink.module.css';

/**
 * A "‹ Parent page" link above a page's title, for pages reached from an
 * overview rather than from the main navigation. The installed app has no
 * browser back button, so without it the way out is not obvious.
 */
export function BackLink({ to, label }: { to: string; label: string }) {
  return (
    <Link to={to} className={styles.back}>
      <ChevronLeftIcon width={14} height={14} />
      {label}
    </Link>
  );
}
